import { useEffect, useState } from 'react';

/** Re-renders the caller every `ms` so time-derived state (e.g. a DJI
 *  telemetry light going Live → Stale → Offline) updates between refetches. */
export function useNow(ms: number, enabled = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => setNow(Date.now()), ms);
    return () => window.clearInterval(id);
  }, [ms, enabled]);
  return now;
}
